// extracted by mini-css-extract-plugin
var _1 = "ServerErrorContainer-F28rB";
var _2 = "ServerErrorHeader-ZRO3T";
var _3 = "ServerErrorSubtitle-GjXAU";
var _4 = "ServerErrorSubtitleContainer-st_um";
var _5 = "ServerErrorTitle-Kvdws";
export { _1 as "ServerErrorContainer", _2 as "ServerErrorHeader", _3 as "ServerErrorSubtitle", _4 as "ServerErrorSubtitleContainer", _5 as "ServerErrorTitle" }
